import { setTransformationType } from './set-transformation-type';
export default setTransformationType;
